import React from 'react';
import { supabaseLocationService } from '../../services/supabaseLocationService';
import { FeaturedToolsSection } from './FeaturedToolsSection';
import { GhgInventorySection } from './GhgInventorySection';
import { HomeHero } from './HomeHero';
import { MembershipFinalCtaSection } from './MembershipFinalCtaSection';
import { PublicVsMembershipSection } from './PublicVsMembershipSection';
import { SuccessStoriesSection } from './SuccessStoriesSection';
import { WhyCoolClimateSection } from './WhyCoolClimateSection';
import './HomePage.css';

export interface HomePageProps {
  onLocationSelect: (location: string) => void;
  loading?: boolean;
  showLocationDevHint?: boolean;
}

export const HomePage: React.FC<HomePageProps> = ({
  onLocationSelect,
  loading = false,
  showLocationDevHint = false,
}) => (
  <div className="overview-page home-page">
    <HomeHero
      onLocationSelect={onLocationSelect}
      showDevHint={!loading && showLocationDevHint}
    />

    <GhgInventorySection />
    <PublicVsMembershipSection />
    <FeaturedToolsSection />
    <WhyCoolClimateSection />
    <SuccessStoriesSection />
    <MembershipFinalCtaSection />

    {supabaseLocationService.isDevFallback() && (
      <p className="home-page__dev-fallback">
        Not connected to database. Copy <code>.env.example</code> to <code>.env</code> in{' '}
        <code>my-app/frontend</code> and add your Supabase URL and anon key to load full location data.
      </p>
    )}
  </div>
);

export default HomePage;
